module.exports = __webpack_public_path__ + "static/media/west-region-states-sm.92ce780a.png";